/**
 * A super admin's own shops, given the Shopify domain the server search found
 * for them so a search by domain still matches them locally; and the other
 * shops found, listed apart (BAB-3035).
 */
export function splitFoundShops<
  TShop extends { id: string; shopifyUrl?: string | null },
>(own: TShop[], found: TShop[]) {
  const foundById = new Map(found.map((shop) => [shop.id, shop]));
  return {
    ownShops: own.map((shop) => {
      const match = foundById.get(shop.id);
      return match ? { ...shop, shopifyUrl: match.shopifyUrl } : shop;
    }),
    otherShops: found.filter(
      (shop) => !own.some((ownShop) => ownShop.id === shop.id),
    ),
  };
}
